import { api, toCamelCase, toSnakeCase } from '../lib/api'
import {
  BankAccount,
  BankAccountCreate,
  BankAccountUpdate,
  SenderProfile,
  SenderProfileCreate,
  SenderProfileUpdate,
  UserPreferences,
  UserPreferencesUpdate,
} from '../types/settings'

// Bank Accounts API
export const bankAccountApi = {
  async getAll(): Promise<BankAccount[]> {
    const response = await api.get('/bank-accounts')
    return response.data.map((item: unknown) =>
      toCamelCase(item as Record<string, unknown>) as unknown as BankAccount
    )
  },

  async getById(id: number): Promise<BankAccount> {
    const response = await api.get(`/bank-accounts/${id}`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as BankAccount
  },

  async create(data: BankAccountCreate): Promise<BankAccount> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.post('/bank-accounts', payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as BankAccount
  },

  async update(id: number, data: BankAccountUpdate): Promise<BankAccount> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.put(`/bank-accounts/${id}`, payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as BankAccount
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/bank-accounts/${id}`)
  },

  async setDefault(id: number): Promise<BankAccount> {
    const response = await api.put(`/bank-accounts/${id}/default`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as BankAccount
  },
}

// Sender Profiles API
export const senderProfileApi = {
  async getAll(): Promise<SenderProfile[]> {
    const response = await api.get('/sender-profiles')
    return response.data.map((item: unknown) =>
      toCamelCase(item as Record<string, unknown>) as unknown as SenderProfile
    )
  },

  async getById(id: number): Promise<SenderProfile> {
    const response = await api.get(`/sender-profiles/${id}`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as SenderProfile
  },

  async create(data: SenderProfileCreate): Promise<SenderProfile> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.post('/sender-profiles', payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as SenderProfile
  },

  async update(id: number, data: SenderProfileUpdate): Promise<SenderProfile> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.put(`/sender-profiles/${id}`, payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as SenderProfile
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/sender-profiles/${id}`)
  },

  async setDefault(id: number): Promise<SenderProfile> {
    const response = await api.put(`/sender-profiles/${id}/default`)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as SenderProfile
  },
}

// User Preferences API
export const userPreferencesApi = {
  async get(): Promise<UserPreferences> {
    const response = await api.get('/users/preferences')
    return toCamelCase(response.data as Record<string, unknown>) as unknown as UserPreferences
  },

  async update(data: UserPreferencesUpdate): Promise<UserPreferences> {
    const payload = toSnakeCase(data as unknown as Record<string, unknown>)
    const response = await api.put('/users/preferences', payload)
    return toCamelCase(response.data as Record<string, unknown>) as unknown as UserPreferences
  },
}
